import showdown from 'showdown';

const Markdown = ({convert, className}) => {
  const converter = new showdown.Converter({
    noHeaderId: true,
    simpleLineBreaks: true,
    openLinksInNewWindow: true
  });
  const copy = converter.makeHtml(convert);
  return <div className={className ? `${className} markdown` : `markdown`} dangerouslySetInnerHTML={{__html: copy}}></div>;
}

export default Markdown;



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Markdown.js